import { all } from 'redux-saga/effects'
import { _updateSidebarToggle, _updateLoginStatus, _updateNotificationCount } from './saga';


export default function* rootSaga() {
    yield all([_updateSidebarToggle, _updateLoginStatus, _updateNotificationCount]);
}